<div class="h-full flex flex-col bg-gray-50 w-full mx-auto pb-10 font-prompt overflow-auto">
    <!-- 1. Header บาร์ด้านบน -->
    <div class="relative w-full  pt-10 pb-5 flex flex-col items-center select-none h-full z-10">
        <!-- ปุ่มย้อนกลับ -->
        <div class="absolute top-4 left-4 z-20">
            <button (click)="goback()"
                class="w-9 h-9 rounded-full bg-gray-50 hover:bg-gray-100 text-gray-700 flex items-center justify-center active:scale-95 transition-all outline-none">
                <img src="icons/arrow_back_black.svg" class="w-full h-full" />
            </button>
        </div>

        <!-- รูปอวตารโปรไฟล์ -->
        <div class="relative mt-2">
            <div
                class="w-24 h-24 rounded-full overflow-hidden border-4 border-white shadow-lg flex items-center justify-center bg-gray-200 cursor-pointer">
                <img *ngIf="pictureUrl; else fallbackAvatar" [src]="pictureUrl" alt="Avatar"
                    class="w-full h-full object-cover">
                <ng-template #fallbackAvatar>
                    <img src="icons/person_slate.svg" class="w-full h-full" />
                </ng-template>
            </div>
            <!-- ปุ่มกดเปลี่ยนรูปภาพ -->
            <!-- <button (click)="fileInput.click()"
                class="absolute bottom-0 right-0 w-8 h-8 bg-amber-500 text-white rounded-full shadow-md flex items-center justify-center hover:bg-amber-600 active:scale-90 transition-all border-2 border-white outline-none">
                <span class="material-symbols-outlined" style="font-size: 18px;">photo_camera</span>
            </button> -->
            <input #fileInput type="file" accept="image/*" class="hidden" (change)="onFileSelected($event)">
        </div>

        <!-- ชื่อผู้ใช้ LINE & ข้อมูลผู้ใช้ -->
        <h2 class="text-base font-bold text-gray-800 mt-3 tracking-wide">{{ displayName }}</h2>
        <!-- <p class="text-[10px] text-gray-400 font-medium tracking-wider">LINE USER ID: {{ uid | slice:0:40 }}...
        </p> -->
    </div>

    <!-- เส้นโค้งตกแต่งคลื่น (Wave Divider) -->
    <div class="w-full h-12 z-9 bg-white relative">
        <svg class="absolute bottom-0 w-full h-8" viewBox="0 0 1440 74" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 24C240 -8 480 -8 720 24C960 56 1200 56 1440 24V74H0V24Z" fill="#F9FAFB" />
            <path opacity="0.3" d="M0 44C240 12 480 12 720 44C960 76 1200 76 1440 44V74H0V44Z" fill="#ffbb00" />
        </svg>
    </div>

    <!-- 2. ฟอร์มข้อมูลส่วนตัว (Edit fields card) -->
    <div class="flex-1 bg-gray-50 px-6 pt-2 pb-24 space-y-4 text-left animation-slide-up">
        <div class="bg-white rounded-3xl p-5 shadow-sm border border-gray-100/50 space-y-4">
            <!-- ชื่อ-สกุล -->
            <div>
                <label class="block font-bold text-xs text-gray-600 mb-1.5">{{
                    currentLang === "TH" ? "ชื่อ-สกุล" : "Full Name"
                    }}</label>
                <input type="text" [(ngModel)]="name" placeholder="คุณ ณัฐพล อัศวาภิรมย์"
                    class="w-full bg-gray-50/50 border border-gray-200 text-sm rounded-xl px-4 py-2.5 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300" />
            </div>

            <!-- อีเมล -->
            <div>
                <label class="block font-bold text-xs text-gray-600 mb-1.5">{{
                    currentLang === "TH" ? "อีเมล" : "Email"
                    }}</label>
                <input type="email" [(ngModel)]="email" placeholder="abc@example.com"
                    class="w-full bg-gray-50/50 border border-gray-200 text-sm rounded-xl px-4 py-2.5 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300" />
            </div>

            <!-- เบอร์ติดต่อ -->
            <div>
                <label class="block font-bold text-xs text-gray-600 mb-1.5">
                    {{ currentLang === "TH" ? "เบอร์ติดต่อ" : "Contact number" }}
                </label>
                <input type="text" [(ngModel)]="phoneOne" (input)="onNumberInput('phoneOne', $event)"
                    placeholder="0812345678" maxlength="10"
                    class="w-full bg-gray-50/50 border border-gray-200 text-sm rounded-xl px-4 py-2.5 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300" />
            </div>

            <!-- วันเดือนปีเกิด -->
            <div>
                <label class="block font-bold text-xs text-gray-600 mb-1.5">
                    {{ currentLang === "TH" ? "วันเดือนปีเกิด" : "Date of birth" }}
                </label>
                <div class="relative">
                    <input matInput [matDatepicker]="dobPicker" [max]="today" [(ngModel)]="dateOfBirth" readonly
                        placeholder="DD/MM/YYYY"
                        class="w-full bg-gray-50/50 border border-gray-200 text-sm rounded-xl pl-4 pr-10 py-2.5 text-gray-800 outline-none focus:bg-white focus:border-amber-400 focus:ring-2 focus:ring-amber-200/50 transition-all placeholder:text-gray-300 cursor-pointer"
                        (click)="dobPicker.open()" />
                    <mat-datepicker-toggle matSuffix [for]="dobPicker"
                        class="absolute top-1/2 right-2 -translate-y-1/2 scale-90"></mat-datepicker-toggle>
                    <mat-datepicker #dobPicker panelClass="modern-yellow-datepicker"></mat-datepicker>
                </div>
            </div>

            <!-- ที่อยู่ออกใบกำกับภาษี -->
            <div class="flex items-center justify-between rounded-xl border border-gray-100 hover:border-amber-200 hover:bg-amber-50/10 p-3.5 transition-all cursor-pointer bg-gray-50/30 group"
                (click)="goAddressPage()">
                <div class="flex items-center gap-3">
                    <span class="transition-colors"><img src="icons/place_black.svg" class="w-full h-full" /></span>
                    <span class="text-xs text-gray-700 font-bold group-hover:text-gray-900 transition-colors">
                        {{ currentLang === "TH" ? "ที่อยู่ออกใบกำกับภาษี" : "Invoice Address" }}
                    </span>
                </div>
                <span class="transition-colors text-lg"><img src="icons/chevron_right_slate.svg" /></span>
            </div>
        </div>

        <!-- ปุ่มบันทึกข้อมูล -->
        <div class="pt-2">
            <button
                class="w-full bg-(--main-color) hover:from-amber-600 hover:to-yellow-500 text-white text-sm font-bold rounded-xl py-3 shadow-[0_4px_12px_rgba(245,158,11,0.25)] transition-all duration-200 active:scale-95 outline-none"
                (click)="saveProfile()">
                {{ currentLang === "TH" ? "บันทึกข้อมูล" : "Save Settings" }}
            </button>
        </div>
    </div>
</div>

<app-pss-loading *ngIf="isLoading"></app-pss-loading>